<template>
  <div class="text-xs text_color cursor-pointer w-full px-2">
    <span class="text-sm text_color">
      {{ displayActivityType }}
    </span>
  </div>
</template>
<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  row: {
    type: Object,
    default: () => ({}),
  },
});

const activityTypeMap = {
  INVITE: "Connection Request",
  INMAIL: "InMail",
  MESSAGE: "Message",
  LOG: "Message",
};

const displayActivityType = computed(() => {
  return activityTypeMap[props.value] || props.value;
});
</script>
